const log = require('log').create('detect_country') // eslint-disable-line

// these commented versions use Number.toLocaleString which doesn't fully work
// in phantomjs and other older browsers. To facilitate testing, I rewrote them
// in more vanilla JS so they work in phantom. If we ever need to support other
// currencies, we should restore the toLocaleString versions and polyfill
// phantom, or updated it, or find a more standards compliant test environment.
// -pascal

// function convertCentsToDollars(cents) {
//     const options = {
//         style: 'currency',
//         currency: 'USD',
//     }
//     const dollars = cents / 100
//
//     return dollars.toLocaleString('en-US', options)
// }

// function convertCentsToSimpleDollars(cents) {
//     const options = {
//         style: 'currency',
//         currency: 'USD',
//     }
//     const dollars = cents / 100
//
//     // if amount is in whole dollars, don't show decimals
//     if (dollars % 1 === 0) options.maximumFractionDigits = 0
//
//     return dollars.toLocaleString('en-US', options)
// }


function convertCentsToDollars(cents) {
    const decimal_places = 2

    // convert cents to absolute value, in dollars, with decimal places
    const dollars = (
        Math.round(Math.abs(cents)) / 100
    ).toFixed(decimal_places)

    // set preceding symbol based on positive/negative value of cents
    const minus = (
        cents >= 0
            ? ''
            : '-'
    )

    return `${minus}$${dollars}`
}

function convertCentsToSimpleDollars(cents) {
    // if value is an even number of dollars, don't show decimal places
    const decimal_places = (
        cents % 100 === 0
            ? 0
            : 2
    )

    // convert cents to absolute value, in dollars, with decimal places
    const dollars = (
        Math.round(Math.abs(cents)) / 100
    ).toFixed(decimal_places)

    // set preceding symbol based on positive/negative value of cents
    const minus = (
        cents >= 0
            ? ''
            : '-'
    )

    return `${minus}$${dollars}`
}

module.exports = {
    convertCentsToDollars,
    convertCentsToSimpleDollars,
}
